export default "<p style=\"margin: 40px; text-align: center;\">Redirecionando...</p>\n"